import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Card from '@components/card'
import Select from '@components/inputs/select'
import { WindowContext } from '@components/windowContextProvider'

import colors from '@settings/styleSettings'

import 'material-icons/iconfont/outlined.css'

import {
  Container,
  SubText,
  Pages,
  Page,
  PageSize,
  SelectLabel,
  Row
} from './styles'

const TablePageHandler = ({
  sizeOnPage,
  page,
  setPage,
  pageSize,
  total,
  setPageSize,
  isloan
}) => {
  const { clientWidth } = useContext(WindowContext)

  const options = [
    { value: 5, label: '5 Linhas' },
    { value: 10, label: '10 Linhas' },
    { value: 20, label: '20 Linhas' },
    { value: 50, label: '50 Linhas' },
  ]
  const selectedOption = _.find(options, ({ value }) => value === pageSize)
  const totalPages = Math.ceil(total / pageSize)

  const ChevronRight = () => <span className="material-icons-outlined">chevron_right</span>
  const ChevronLeft = () => <span className="material-icons-outlined">chevron_left</span>

  function renderPages() {
    const renderPage = (pageRep) => (
      <Page
        key={pageRep}
        onClick={() => setPage(pageRep - 1)}
        actualpage={+(page === pageRep)}
      >
        {pageRep || ''}
      </Page>
    )

    const renderTop = () => (
      <>
        <Page>...</Page>
        {renderPage(totalPages)}
      </>
    )

    const renderBottom = () => (
      <>
        {renderPage(1)}
        <Page>...</Page>
      </>
    )

    if (totalPages <= 5) {
      const numPages = []
      for (let i = 1; i <= totalPages; i += 1) {
        numPages.push(i)
      }
      return <>{_.map(numPages, renderPage)}</>
    }
    if (page < 4) {
      if (clientWidth < 460) {
        return (
          <>
            {_.map([1, 2, 3], renderPage)}
            {renderTop()}
          </>
        )
      }
      return (
        <>
          {_.map([1, 2, 3, 4, 5], renderPage)}
          {renderTop()}
        </>
      )
    }

    if (page > totalPages - 3) {
      if (clientWidth < 340) {
        return (
          <>
            {renderBottom()}
            {_.map(
              [
                totalPages - 2,
                totalPages - 1,
                totalPages,
              ],
              renderPage
            )}
          </>
        )
      }
      return (
        <>
          {renderBottom()}
          {_.map(
            [
              totalPages - 4,
              totalPages - 3,
              totalPages - 2,
              totalPages - 1,
              totalPages,
            ],
            renderPage
          )}
        </>
      )
    }
    if (clientWidth < 340) {
      return (
        <>
          {renderBottom()}
          {_.map([page], renderPage)}
          {renderTop()}
        </>
      )
    }
    if (clientWidth < 550) {
      return (
        <>
          {renderBottom()}
          {_.map([page - 1, page, page + 1], renderPage)}
          {renderTop()}
        </>
      )
    }
    return (
      <>
        {renderBottom()}
        {_.map([page - 2, page - 1, page, page + 1, page + 2], renderPage)}
        {renderTop()}
      </>
    )
  }
  const chevronPage = (Chevron, onClick) => (
    <Page
      onClick={onClick}
      style={{
        border: `1px solid ${colors.softGray}`,
      }}
    >
      <Chevron />
    </Page>
  )

  const getSubText = () => {
    if (total < pageSize) {
      const numPages = []
      for (let i = 1; i <= totalPages; i += 1) {
        numPages.push(i)
      }
      if (clientWidth < 820) return `${sizeOnPage}-${total}`
      return `${sizeOnPage}-${total} resultados`
    }
    const interval = (page - 1) * pageSize
    const final = interval + pageSize < total ? interval + pageSize : total
    if (clientWidth < 820) return `${interval + 1}-${final} de ${total}`
    return `${interval + 1}-${final} de ${total} resultados`
  }

  function renderPageWeb() {
    return (
      <Card
        style={isloan ? {
          width: '100%',
          margin: 0,
          borderRadius: '0px 0px 12px 12px',
          padding: '16px 0px'
        } : undefined}
      >
        <Container>
          <SubText>{getSubText()}</SubText>
          <Pages>
            {chevronPage(ChevronLeft, () => page !== 1 && setPage(page - 2))}
            {renderPages()}
            {chevronPage(
              ChevronRight,
              () => page !== totalPages && setPage(page)
            )}
          </Pages>
          <PageSize>
            <SelectLabel style={{ marginRight: 14 }}>Mostrar:</SelectLabel>
            <Select
              value={selectedOption}
              onChange={(e) => setPageSize(e.value)}
              options={options}
            />
          </PageSize>
        </Container>
      </Card>
    )
  }

  function renderPageMobile() {
    return (
      <Card style={isloan ? { width: '100%' } : undefined}>
        <Container>
          <Row>
            <SubText>{getSubText()}</SubText>
            <PageSize>
              <SelectLabel style={{ marginRight: 14 }}>Mostrar:</SelectLabel>
              <Select
                value={selectedOption}
                onChange={(e) => setPageSize(e.value)}
                options={options}
              />
            </PageSize>
          </Row>
          <Row>
            <Pages>
              {chevronPage(ChevronLeft, () => page !== 1 && setPage(page - 2))}
              {renderPages()}
              {chevronPage(
                ChevronRight,
                () => page !== totalPages && setPage(page)
              )}
            </Pages>
          </Row>

        </Container>
      </Card>
    )
  }
  if (clientWidth < 820) return (<>{renderPageMobile()}</>)
  return (<>{renderPageWeb()}</>)

}

TablePageHandler.propTypes = {
  page: PropTypes.number,
  sizeOnPage: PropTypes.number,
  setPage: PropTypes.func.isRequired,
  pageSize: PropTypes.number,
  setPageSize: PropTypes.func.isRequired,
  total: PropTypes.number,
  isloan: PropTypes.bool,
}

TablePageHandler.defaultProps = {
  page: 0,
  sizeOnPage: 0,
  pageSize: 0,
  total: 0,
  isloan: false,
}

export default TablePageHandler
